import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { emptyArray } from 'ui-components/default-props/empty';
import { PackageService } from '../../../services/package-service';
import Global from '../../../store/global-selectors';
import PackageDropdownContainer from '../../package-dropdown/container';
import { packageTypeId, dimensions } from '../constants';
import messages from '../messages';

const isNotMultipackage = (p) => p.value !== '**MULTIPACKAGE**';

const PackageTypePresetOption = ({ data, onChange, selectedPackageCarrierId }) => {
  const packageId = useSelector((state) => {
    const packages = Global.selectSellerPackages(state) || emptyArray;
    const foundPackage = PackageService.findBestGuessPackageByPackageTypeId(data, packages, selectedPackageCarrierId);
    return foundPackage?.packageId;
  });
  const onPackageSelected = useCallback(
    (p) => {
      if (p?.isCustom) {
        onChange({ name: dimensions, value: p.dimensions });
      }
      onChange({
        name: packageTypeId,
        value: p?.packageTypeId,
        carrierId: p?.carrierId,
      });
    },
    [onChange],
  );

  return (
    <>
      <Text textType={TextType.Label} value={messages.packageTypeId} />
      <PackageDropdownContainer
        dropdownMenuShouldHaveWidthOfButton
        fullWidth
        onPackageSelected={onPackageSelected}
        packageFilter={isNotMultipackage}
        selectedPackageCarrierId={selectedPackageCarrierId}
        selectedPackageKey={packageId}
        simpleToggler
        theme={THEME_CONSTANTS.unstyled}
        variant='form'
      />
    </>
  );
};

PackageTypePresetOption.propTypes = {
  data: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  selectedPackageCarrierId: PropTypes.string,
};

export default PackageTypePresetOption;
